import { computed, reactive } from '@nuxtjs/composition-api';
import { StateAutocompleteInterface, UseAutocompleteInterface } from '~/composables/useAutocomplete/useAutocomplete';
import axios from 'axios';
import { escapeSearchSpecialChars } from '~/utils/solepro/functions';

const state = reactive<StateAutocompleteInterface>({
    suggestedTerms: []
});

/**
 * Global store for managing UI state.
 *
 * See the {@link UseAutocompleteInterface} for a list of methods and values available in this composable.
 */
export function useAutocomplete(): UseAutocompleteInterface {
  const loadSuggestedTermsResults = async (term: String, setInState = true, fuzzyTerm?: string) => {
    const escapedTerm = escapeSearchSpecialChars(term as string);
    const apiResult = await axios.get(`/sole-api/autocomplete/suggest?q=${encodeURIComponent(escapedTerm)}`);

    try {
      const data = apiResult.data;
      const uniqueValuesMap = new Map();

      data.forEach((item) => {
        const suggestedTerm = (item.extra_info?.split('||')[2] || '').trim();
        const queriedTerm = item.query.replace(/§/g, "");
        if (!suggestedTerm) return;

        const dedupeKey = suggestedTerm.toLowerCase().replace(/\s+/g, ' ').trim();
        if (!uniqueValuesMap.has(dedupeKey)) {
          uniqueValuesMap.set(dedupeKey, {
            suggestedTerm,
            queriedTerm
          });
        }
      });

      const uniqueValues = Array.from(uniqueValuesMap.values());
      if (setInState) {
        state.suggestedTerms = uniqueValues as any;
      }
      if (uniqueValues.length < 1 && fuzzyTerm && fuzzyTerm!=term) { // se sono uguali devo uscire dalla ricorsione, altrimenti andrebbe in loop
        await loadSuggestedTermsResults(fuzzyTerm, setInState, fuzzyTerm);
      }
    } catch (e) {
      console.error("### - Error during autocomplete fetch - ###", e)
    }
  }

  const resetSuggestedTerms = () => state.suggestedTerms = [];

  return {
    // @ts-ignore
    suggestedTerms: computed(() => state.suggestedTerms ),
    resetSuggestedTerms,
    loadSuggestedTermsResults,
  };
}

export * from './useAutocomplete';
export default useAutocomplete;
